import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-slider",
  "use": "icon-slider-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-slider\"><defs><style type=\"text/css\"></style></defs><path d=\"M951.453125 476.84375H523.671875a131.8359375 131.8359375 0 0 0-254.1796875 0H72.546875v70.3125h196.9453125a131.8359375 131.8359375 0 0 0 254.1796875 0H951.453125z\" p-id=\"1239\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol